import { useState } from "react";
import AllPcode from "../../../components/userPcode"
import "./detailsStyle.css";
import LocationTypeSearch from "../../../components/locationTypeSearch";
import CustomerTypeSearch from "../../../components/customerTypeSearch/customerTypeSearch";
import { salesAPI } from "../../../api/salesAPI";
import { OpenReport } from "../../../utils/openReport";
import Spinner from "../../../components/spinner/spinner";
import { toast } from "react-toastify";

export default function Details() {
    const [selectedPcode, setSelectedPcode] = useState('');
    const [locCode, setLocCode] = useState('');
    const [locName, setLocName] = useState('');
    const [cusCode, setCusCode] = useState('');
    const [cusName, setCusName] = useState('');
    const currentDate = new Date();
    const [fromDate, setFromDate] = useState(currentDate.toISOString().split('T')[0]);
    const [toDate, setToDate] = useState(currentDate.toISOString().split('T')[0]);
    const [isAllLocCodeChecked, setIsAllLocCodeChecked] = useState(true);
    const [isAllCusCodeChecked, setIsAllCusCodeChecked] = useState(true);
    const [loading, setLoading] = useState(false);

    const formatDate = (date) => {
        return date.toISOString().split('T')[0];
    };

    // Handle Location  change
    const handleLocationChange = (e) => {
        setIsAllLocCodeChecked(e.target.checked);
        if (e.target.checked) {
            setLocCode('');
            setLocName('');
        }
    };

    // Handle Customer  change
    const handleCustomerChange = (e) => {
        setIsAllCusCodeChecked(e.target.checked);
        if (e.target.checked) {
            setCusCode('');
            setCusName('');
        }
    };

    const handlePreviewRpt = () => {
        setLoading(true);

        if (!isAllLocCodeChecked && !locCode) {
            toast.warning("Select the location");
            setLoading(false);
            return;
        }
        if (!isAllCusCodeChecked && !cusCode) {
            toast.warning("Select the customer");
            setLoading(false);
            return;
        }
        if (!fromDate) {
            toast.warning("From date is required");
            setLoading(false);
            return;
        }
        if (!toDate) {
            toast.warning("To date is required");
            setLoading(false);
            return;
        }

        const formattedFromDate = new Date(fromDate).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
        const formattedToDate = new Date(toDate).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
        const reportName = `Sales Details Report From ${formattedFromDate} To ${formattedToDate}.pdf`;
        salesAPI.getSalesDetailsRpt(selectedPcode, locCode, locName, cusCode, fromDate, toDate)
            .then((response) => {
                if (response.report) {
                    OpenReport(response.report, reportName);
                    handleClear();
                } else {
                    console.error("No report data found");
                }
            })
            .catch((error) => {
                console.error("Error fetching report data:", error);
            }).finally(() => {
                setLoading(false);
            });
    };

    const handleClear = () => {
        setLocCode('');
        setLocName('');
        setCusCode('');
        setCusName('');
        setFromDate(currentDate.toISOString().split('T')[0]);
        setToDate(currentDate.toISOString().split('T')[0]);
        setIsAllLocCodeChecked(true);
        setIsAllCusCodeChecked(true);
    }

    return (
        <>
            {
                selectedPcode &&
                <LocationTypeSearch setLocCode={setLocCode} setLocName={setLocName}
                    pCode={selectedPcode}
                    setIsAllLocationsChecked={setIsAllLocCodeChecked} />
            }
            {
                selectedPcode &&
                <CustomerTypeSearch setCusCode={setCusCode} setCusName={setCusName}
                    pCode={selectedPcode}
                    setIsAllCustomersChecked={setIsAllCusCodeChecked} />
            }

            {loading && (
                <div className="loading-overlay">
                    <Spinner />
                    <div>Loading...</div>
                </div>
            )}
            {!loading && (
                <div className="container">
                    <div className='row'>
                        <div className='col-xs-0 col-sm-0 col-md-3 col-lg-3 col-xl-3 col-xxl-3'></div>
                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 form__body'>
                            <h6 className='text-center'>Sales Details</h6>
                            <form>
                                <div class="form-group row">
                                    <label for="staticEmail" class="col-xs-12 col-sm-12 col-md-6 col-lg-12 col-xl-12 col-form-label">Profit Center</label>
                                    <div class="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-11 col-xl-11">
                                        <AllPcode setSelectedPcode={setSelectedPcode} />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="staticEmail" class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-form-label">Location</label>
                                    <div class="col-9 col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                                        <input type="text" class="form-control" id="inputPassword" value={locCode} />
                                    </div>
                                    <div className="col-3 col-xs-12 col-sm-12 col-md-3 col-lg-1 col-xl-1 text-center px-0">
                                        <button type="button" className="btn btn-sm btn-secondary m-0 px-sm-1" data-bs-toggle="modal"
                                            data-bs-target="#locationTypeSearch"><span className="small">Find</span></button>
                                    </div>
                                    <div class="col-9 col-xs-12 col-sm-12 col-md-3 col-lg-6 col-xl-6">
                                        <input type="text" class="form-control" id="inputPassword" value={locName}
                                            onChange={(e) => setLocName(e.target.value)} />
                                    </div>
                                    <div class="col-2 col-xs-12 col-sm-12 col-md-3 col-lg-1 col-xl-1 form-check">
                                        <input class="form-check-input" type="checkbox" value="" id="flexCheckChecked"
                                            checked={isAllLocCodeChecked}
                                            onChange={handleLocationChange} />
                                        <label class="form-check-label" for="flexCheckChecked">
                                            All
                                        </label>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="staticEmail" class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-form-label">Customer</label>
                                    <div class="col-9 col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                                        <input type="text" class="form-control" id="inputPassword" value={cusCode} />
                                    </div>
                                    <div className="col-3 col-xs-12 col-sm-12 col-md-3 col-lg-1 col-xl-1 text-center px-0">
                                        <button type="button" className="btn btn-sm btn-secondary m-0 px-sm-1" data-bs-toggle="modal"
                                            data-bs-target="#customerTypeSearch"><span className="small">Find</span></button>
                                    </div>
                                    <div class="col-9 col-xs-12 col-sm-12 col-md-3 col-lg-6 col-xl-6">
                                        <input type="text" class="form-control" id="inputPassword" value={cusName} />
                                    </div>
                                    <div class="col-3 col-xs-12 col-sm-12 col-md-3 col-lg-1 col-xl-1 form-check">
                                        <input class="form-check-input" type="checkbox" value="" id="flexCheckChecked"
                                            checked={isAllCusCodeChecked}
                                            onChange={handleCustomerChange} />
                                        <label class="form-check-label" for="flexCheckChecked">
                                            All
                                        </label>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="staticEmail" class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-form-label">Date From</label>
                                    <div class="col-9 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <input type="date" class="form-control" id="inputPassword"
                                            value={fromDate}
                                            onChange={(e) => setFromDate(e.target.value)} />
                                    </div>
                                    <label for="staticEmail" class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-form-label">Date To</label>
                                    <div class="col-9 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <input type="date" class="form-control" id="inputPassword"
                                            value={toDate}
                                            onChange={(e) => setToDate(e.target.value)} />
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6'>
                                        <button type="button" className="btn btn-dark form-control mt-1" onClick={handlePreviewRpt} >Preview</button>
                                    </div>
                                    <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6'>
                                        <button type="button" className="btn btn-secondary form-control mt-1" onClick={handleClear} >Clear</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className='col-xs-0 col-sm-0 col-md-3 col-lg-3 col-xl-3 col-xxl-3'></div>
                    </div>
                </div>
            )}
        </>
    );
}